import { useUserStore } from "../../state";
import { useCompanyStore } from "../../state/useCompanyStore";
import TourGuideComponent from "./SideBar";

export const useCreateServiceTourGuide = () => {
  const { company: user, updateProfile } = useCompanyStore();

  const createServiceTourGuide = [
    {
      target: "#select-service-type",
      disableBeacon: true,
      content: (
        <TourGuideComponent
          body="Choose if this service is billed by time (hourly, daily) or by session (flat rate per task)."
          progress="Step 1 of 1"
          title="Choose Service Type"
        />
      ),
      placement: "right" as const,
      locale: {
        skip: <span className="text-[#344054]">Skip</span>,
        next: <span className="text-[#ffffff] bg-transparent">Next</span>,
        last: (
          <span
            onClick={() => {
              updateProfile({
                prefs: {
                  ...user.prefs,
                  isFirstService: false,
                },
              });
            }}
            className="text-[#ffffff] bg-transparent"
          >
            Finish up
          </span>
        ),
      },
      showProgress: false,
      scrollOffset: 80,
      styles: {
        tooltip: { background: "#ffffff" },
        beaconInner: { background: "#ffffff" },
      },
    },
  ];

  return { createServiceTourGuide };
};
